export enum InvoiceType {
  SINGLE = 'single',
  COLLECTIVE = 'collective',
  SELF_BILLING = 'self-billing',
}
